import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { RawTeamSessionData } from './types'

export const teamSessionsAdapter = createEntityAdapter<RawTeamSessionData>()

export const initialTeamsSessionsState = teamSessionsAdapter.getInitialState({
  selectedTeamId: null
})

export const teamSessionsSlice = createSlice({
  name: 'teamSessions',
  initialState: initialTeamsSessionsState,
  reducers: {
    upsertOne: teamSessionsAdapter.upsertOne,
    upsertMany: teamSessionsAdapter.upsertMany,
    removeOne: teamSessionsAdapter.removeOne,
    removeAll: teamSessionsAdapter.removeAll
  }
})

export const reducer = teamSessionsSlice.reducer

export const {
  upsertOne: upsertOneTeamSession,
  upsertMany: upsertManyTeamSessions,
  removeOne: removeOneTeamSession,
  removeAll: removeAllTeamSessions
} = teamSessionsSlice.actions
